<template>
  <div style="height: 36px;">
    <canvas ref="canvas" width="192" height="72" style="width: 96px; height: 36px;"></canvas>
  </div>
</template>

<script>
const rawPower = {
  toStringValue(value) {
    return `${value.toFixed(0)} W`;
  },
};

const rawDigital = {
  toStringValue(value) {
    return `${value.toFixed(0)}`;
  },
};

const rawDigitalPercent = {
  toStringValue(value, factor) {
    const f = factor||100;
    return `${value.toFixed(0)}\n${!factor?'~':''}${(value/f).toFixed(0)}%`;
  },
};

const voltageVolts = {
  toStringValue(value) {
    return `${(value / 1000000).toFixed(1)} V`;
  }
};

const dutycyclePercent = {
  toStringValue(value) {
    return `${value / 1000}%`;
  },
};

const dutycyclePercentIncorrectlyScaled = {
  toStringValue(value) {
    return `${value}%`;
  },
};

const digitalPercent = {
  toStringValue(value) {
    return `${value * 100}%`;
  },
};

const conversionById = {
  rawPower,
  rawDigital,
  rawDigitalPercent,
  voltageVolts,
  dutycyclePercent,
  dutycyclePercentIncorrectlyScaled,
  digitalPercent,
};

export default {
  props: [
    'name',
    'conversion',
    'value',
    'factor',
  ],

  data: () => ({
    text: null,
  }),

  mounted() {
    this.updateText();
    this.updateCanvas();
  },

  watch: {
    value() {
      this.updateText();
      this.updateCanvas();
    },
  },

  methods: {
    updateText() {
      if (this.value) {
        const conv = conversionById [this.conversion];
        this.text = conv.toStringValue(this.value.value, this.factor);
      } else {
        this.text = '---';
      }
    },

    updateCanvas() {
      const ctx = this.$refs.canvas.getContext('2d');

      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      ctx.save();
      ctx.scale(2, 2);

      ctx.clearRect(0, 0, 36, 36);

      ctx.beginPath();
      ctx.arc(18, 18, 16, 0, 2 * Math.PI);
      ctx.closePath();

      if (this.value && this.value.value) {
        ctx.fillStyle = 'rgb(0, 192, 0)';
      } else {
        ctx.fillStyle = 'rgb(0, 64, 0)';
      }
      ctx.fill();

      ctx.strokeStyle = 'black';
      ctx.stroke();

      ctx.fillStyle = 'black';

      ctx.font = '500 14px "Roboto", sans-serif';
      ctx.fillText(this.name, 40, 14);

      const parts = this.text.split('\n', 2);
      if(parts.length > 1){
        ctx.font = '500 14px "Roboto", sans-serif';
        ctx.fillText(parts[0], 40, 32);
        ctx.font = '500 12px "Roboto", sans-serif';
        ctx.fillText(parts[1].padStart(4,' '), 4, 23);
      }else{
        ctx.font = '500 14px "Roboto", sans-serif';
        ctx.fillText(this.text, 40, 32);
      }
      ctx.restore();
    }
  }
};
</script>

<style scoped>

</style>
